import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { I18nNamespace } from '~/common/types';
import { locationLabel, LocationLabelOptions, Location } from '~/util/string';

export const useLocationLabel = (value: Union.Nullable<Location>, options?: LocationLabelOptions): string | null => {
  const { t } = useTranslation(I18nNamespace.countries, {});
  const translateLocation = useMemo(() => locationLabel(t), [t]);
  return useMemo(() => {
    return translateLocation(value, {
      divider: options?.divider,
    });
  }, [value, translateLocation, options?.divider]);
};
